import { _ as __rest } from './_tslib.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { generateClasses } from '@ids/tools';
import { useMemo } from 'react';
import { I as IdsIcon } from './icon.js';
import { s as styleInject } from './style-inject.es.js';

var css_248z = ".ids-sort__content,\n:host.ids-sort__content {\n  color: var(--ids_color_text_heading_01);\n  font: var(--ids_textStyle_f02_s16_h24_wbd);\n  padding: 0 var(--ids_spacing_4x);\n}\n.ids-sort__content:hover {\n  background-color: var(--ids_color_bg_variant_02);\n  color: var(--ids_color_text_heading_01);\n}\n.ids-sort__content:active {\n  background-color: var(--ids_color_action_neutral_base);\n  color: var(--ids_color_action_primary_contrast);\n}\n\n.ids-sort__content,\n:host.ids-sort__content {\n  background-color: var(--ids_color_bg_base);\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: var(--ids_size_general_48x);\n  overflow: hidden;\n  text-align: center;\n  text-overflow: ellipsis;\n  vertical-align: middle;\n  white-space: nowrap;\n  width: var(--ids_size_general_64x);\n}\n\n.ids-sort__content:first-child {\n  border-top-left-radius: var(--ids_size_cornerRadius_tags_01);\n}\n.ids-sort__content:last-child {\n  border-top-right-radius: var(--ids_size_cornerRadius_tags_01);\n}\n\n/*\n** Voxel Foundation Formats\n*/\n.ids-sort,\n:host.ids-sort {\n  /* stylelint-disable-next-line no-descending-specificity */\n}\n.ids-sort__content,\n:host.ids-sort__content {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border: 0;\n  cursor: pointer;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: var(--ids_spacing_2x);\n  height: 100%;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  outline-offset: -0.0625rem;\n  width: 100%;\n}\n.ids-sort:not(:last-child) .ids-sort__content,\n:host.ids-sort:not(:last-child) .ids-sort__content {\n  border-top-right-radius: 0;\n}\n.ids-sort:not(:first-child),\n:host.ids-sort:not(:first-child) {\n  /* stylelint-disable-next-line no-descending-specificity */\n}\n.ids-sort:not(:first-child) .ids-sort__content,\n:host.ids-sort:not(:first-child) .ids-sort__content {\n  border-top-left-radius: 0;\n}\n.ids-sort__icon,\n:host.ids-sort__icon {\n  min-width: var(--ids_size_general_14x);\n}";
styleInject(css_248z);

const IdsSort = _a => {
  var {
      children,
      className = '',
      direction
    } = _a,
    props = __rest(_a, ["children", "className", "direction"]);
  const classes = useMemo(() => generateClasses({
    'ids-sort': true,
    [className]: className
  }), [className]);
  return jsx("th", Object.assign({
    className: classes
  }, {
    children: jsxs("button", Object.assign({}, props, {
      className: "ids-sort__content"
    }, {
      children: [children, jsx(IdsIcon, Object.assign({
        size: "S"
      }, {
        children: direction ? direction === 'asc' ? 'sort_down' : 'sort_up' : 'ordenar'
      }))]
    }))
  }));
};

export { IdsSort as I };
//# sourceMappingURL=sort.js.map
